<template>
	<div class="round-result">
		<div class="round-participants" :class="{'conflict': currentRound.match_status === 'CONFLICT' && !isMobile}">
			<div class="participant" :class="{'pointer': firstParticipant.team, 'disabled': !isAvailableParticipants, 'none-border': isMobile, 'lose': (isFinishRound && currentRound.winner_id !== firstParticipant.id ? 'disabled' : '')}" v-if="firstParticipant">
				<UiAvatar @click="firstParticipant.team ? $router.push({ name: 'team', params: { id: firstParticipant.team.id } }) : ''" :size="isMobile ? 60 : 70" :src="firstParticipant.getAvatar()"></UiAvatar>
				<div class="nickname" @click="firstParticipant.team ? $router.push({ name: 'team', params: { id: firstParticipant.team.id } }) : ''">{{ firstParticipant.getName() }}</div>
				<div class="psn" v-if="getProfileForTournament && !tournament.isTeamType()">PSN {{ firstParticipant.profile.info.id }}</div>
				<div class="score-input">
					<input type="number" v-model="first" :disabled="!isAvailableParticipants || isFinishRound" :class="{'is-active': secondScore || firstScore}" min="0" placeholder="0" value="0">
				</div>
			</div>
			<div class="participant" :class="{'disabled': !isAvailableParticipants, 'none-border': isMobile}" v-else>
				<UiAvatar :size="isMobile ? 60 : 70" :src="null"></UiAvatar>
				<div class="nickname">Not assigned yet</div>
				<div class="score-input">
					<input type="number" disabled>
				</div>
			</div>
			<div class="separator">
				<svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M18.7172 17.7167L16.2147 15.2142L17.0947 13.5126C17.2791 13.5752 17.4793 13.5736 17.6627 13.508C17.8461 13.4424 18.0019 13.3166 18.1047 13.1512C18.2076 12.9858 18.2514 12.7905 18.2292 12.597C18.2069 12.4035 18.1199 12.2232 17.9821 12.0855C17.8444 11.9478 17.6641 11.8607 17.4706 11.8385C17.2771 11.8162 17.0818 11.8601 16.9164 11.9629C16.751 12.0658 16.6253 12.2215 16.5597 12.4049C16.494 12.5883 16.4924 12.7885 16.555 12.9729L15.3381 13.602C14.8981 13.1448 14.6713 12.6258 14.7606 12.3164L13.475 11.0308L11 8.55576L5.98813 3.54045L2.0625 2.09326L3.50969 6.01545L12.2856 14.7811C12.595 14.6951 13.1141 14.9186 13.5713 15.3586L12.9422 16.5754C12.7578 16.5128 12.5576 16.5145 12.3742 16.5801C12.1908 16.6457 12.035 16.7715 11.9321 16.9369C11.8293 17.1023 11.7854 17.2976 11.8077 17.4911C11.83 17.6846 11.917 17.8648 12.0548 18.0026C12.1925 18.1403 12.3727 18.2274 12.5662 18.2496C12.7597 18.2719 12.9551 18.228 13.1205 18.1252C13.2859 18.0223 13.4116 17.8665 13.4772 17.6831C13.5428 17.4998 13.5445 17.2996 13.4819 17.1151L15.1834 16.2351L17.6859 18.7376C17.6663 18.9686 17.7182 19.2001 17.8345 19.4007C17.9508 19.6012 18.126 19.7612 18.3362 19.8589C18.5464 19.9566 18.7816 19.9873 19.0099 19.9469C19.2382 19.9065 19.4486 19.7969 19.6125 19.633C19.7765 19.469 19.886 19.2587 19.9265 19.0304C19.9669 18.8021 19.9361 18.5669 19.8384 18.3567C19.7407 18.1464 19.5808 17.9713 19.3802 17.855C19.1797 17.7386 18.9482 17.6868 18.7172 17.7064V17.7167ZM3.13844 3.1692L5.59281 4.12482L5.6375 5.67857L3.13844 3.1692ZM19.0781 19.1089C19.0242 19.1624 18.9556 19.1988 18.881 19.2134C18.8064 19.228 18.7291 19.2202 18.6589 19.191C18.5887 19.1618 18.5288 19.1124 18.4866 19.0492C18.4444 18.9859 18.4219 18.9116 18.4219 18.8356C18.4219 18.7596 18.4444 18.6853 18.4866 18.622C18.5288 18.5588 18.5887 18.5094 18.6589 18.4802C18.7291 18.451 18.8064 18.4432 18.881 18.4578C18.9556 18.4724 19.0242 18.5088 19.0781 18.5623C19.1142 18.5981 19.1428 18.6407 19.1623 18.6876C19.1819 18.7345 19.1919 18.7848 19.1919 18.8356C19.1919 18.8864 19.1819 18.9367 19.1623 18.9836C19.1428 19.0305 19.1142 19.0731 19.0781 19.1089Z" fill="#00E7DF"/>
					<path d="M9.71429 14.7811L10.7455 13.7499L8.26366 11.2817L7.23242 12.313C7.31835 12.6224 7.09491 13.1414 6.65491 13.5986L5.43804 12.9696C5.50065 12.7851 5.49901 12.5849 5.43339 12.4015C5.36777 12.2182 5.24204 12.0624 5.07664 11.9595C4.91124 11.8567 4.7159 11.8128 4.52241 11.8351C4.32891 11.8573 4.14864 11.9444 4.01091 12.0821C3.87319 12.2198 3.78612 12.4001 3.76386 12.5936C3.7416 12.7871 3.78546 12.9824 3.88831 13.1478C3.99116 13.3132 4.14695 13.439 4.33034 13.5046C4.51372 13.5702 4.71392 13.5718 4.89835 13.5092L5.77835 15.2108L3.28273 17.7167C3.05172 17.6971 2.82026 17.749 2.61971 17.8653C2.41916 17.9816 2.2592 18.1568 2.16149 18.367C2.06379 18.5772 2.03306 18.8124 2.07346 19.0407C2.11387 19.269 2.22346 19.4794 2.3874 19.6433C2.55133 19.8073 2.76169 19.9168 2.98998 19.9573C3.21827 19.9977 3.45347 19.9669 3.66371 19.8692C3.87396 19.7715 4.04909 19.6116 4.16541 19.411C4.28172 19.2105 4.33358 18.979 4.31398 18.748L6.81648 16.2455L8.51804 17.1255C8.45543 17.3099 8.45707 17.5101 8.52269 17.6935C8.58831 17.8769 8.71404 18.0327 8.87944 18.1355C9.04484 18.2384 9.24018 18.2822 9.43367 18.26C9.62717 18.2377 9.80744 18.1507 9.94516 18.0129C10.0829 17.8752 10.17 17.6949 10.1922 17.5014C10.2145 17.3079 10.1706 17.1126 10.0678 16.9472C9.96492 16.7818 9.80913 16.6561 9.62574 16.5905C9.44235 16.5248 9.24216 16.5232 9.05773 16.5858L8.42866 15.3689C8.88585 14.9289 9.40491 14.7055 9.71429 14.7811ZM3.46491 19.1089C3.41115 19.163 3.34255 19.1998 3.26782 19.2148C3.19308 19.2298 3.11557 19.2223 3.04511 19.1932C2.97465 19.1642 2.91441 19.1148 2.87202 19.0515C2.82963 18.9881 2.80701 18.9136 2.80701 18.8374C2.80701 18.7611 2.82963 18.6866 2.87202 18.6233C2.91441 18.5599 2.97465 18.5106 3.04511 18.4815C3.11557 18.4524 3.19308 18.4449 3.26782 18.4599C3.34255 18.4749 3.41115 18.5118 3.46491 18.5658C3.53671 18.6379 3.57701 18.7356 3.57701 18.8374C3.57701 18.9391 3.53671 19.0368 3.46491 19.1089Z" fill="#00E7DF"/>
					<path d="M18.4904 6.01545L19.9376 2.09326L16.012 3.54045L11.2441 8.3117L13.7054 10.8004L18.4904 6.01545ZM16.4073 4.12482L18.8616 3.17951L16.3626 5.66826L16.4073 4.12482Z" fill="#00E7DF"/>
				</svg>
			</div>
			<div v-if="secondParticipant" class="participant" :class="{
				'revert': isRevert(secondParticipant),
				'none-border': isMobile,
				'pointer': secondParticipant.team,
				'lose': (isFinishRound && currentRound.winner_id !== secondParticipant.id ? 'disabled' : ''),
				'disabled': !isAvailableParticipants}" >
				<UiAvatar @click="secondParticipant.team ? $router.push({ name: 'team', params: { id: secondParticipant.team.id } }) : ''" :size="isMobile ? 60 : 70" :src="secondParticipant.getAvatar()"></UiAvatar>
				<div class="nickname" @click="secondParticipant.team ? $router.push({ name: 'team', params: { id: secondParticipant.team.id } }) : ''">{{ secondParticipant.getName() }}</div>
				<div class="psn" v-if="getProfileForTournament && isAvailableParticipants && !tournament.isTeamType()">PSN {{ secondParticipant.profile.info.id }}</div>
				<div class="score-input">
					<input type="number" v-model="two" :disabled="!isAvailableParticipants || isFinishRound" :class="{'is-active': secondScore || firstScore}" min="0" placeholder="0" value="0">
				</div>
			</div>
			<div class="participant" :class="{'disabled': !isAvailableParticipants, 'none-border': isMobile,}" v-else>
				<UiAvatar :size="isMobile ? 60 : 70" :src="null"></UiAvatar>
				<div class="nickname">Not assigned yet</div>
				<div class="psn" v-if="getProfileForTournament && isAvailableParticipants && !tournament.isTeamType()">{{ secondParticipant.profile.info.id }}</div>
				<div class="psn" v-else>WAIT</div>
				<div class="score-input">
					<input type="number" value="0" disabled>
				</div>
			</div>
		</div>
		<UiButton
			:type="'primary'"
			@click="sendResult"
			:disabled="(!secondScore && !firstScore) || blockSendScore || !isAvailableParticipants || isFinishRound"
		>
			<template v-if="(!secondScore && !firstScore) || blockSendScore || !isAvailableParticipants">
				<svg width="15" height="11" viewBox="0 0 15 11" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path d="M5.73047 10.7812C6.00391 11.0547 6.46875 11.0547 6.74219 10.7812L14.7812 2.74219C15.0547 2.46875 15.0547 2.00391 14.7812 1.73047L13.7969 0.746094C13.5234 0.472656 13.0859 0.472656 12.8125 0.746094L6.25 7.30859L3.16016 4.24609C2.88672 3.97266 2.44922 3.97266 2.17578 4.24609L1.19141 5.23047C0.917969 5.50391 0.917969 5.96875 1.19141 6.24219L5.73047 10.7812Z" fill="#00E7DF"/>
				</svg>
				RESULT SENT
			</template>
			<template v-else>
				SET SCORE
			</template>
		</UiButton>
	</div>
</template>
<script>
import UiAvatar from '../../../../components/UiAvatar'
import UiButton from '../../../../components/UiButton'
import { mapActions, mapGetters } from 'vuex'
export default {
	props: {
		firstParticipant: {
			type: Object,
			required: true
		},
		secondParticipant: {
			required: false
		}
	},
	computed: {
		...mapGetters({
			isMobile: 'dom/isMobile',
			user: 'user/getCurrentUser',
			teams: 'user/currentTeams',
			getProfileForTournament: 'user/getProfileForTournament',
			participants: 'user/getTournamentsParticipants',
			tournament_id: 'tournaments/getCurrentTournamentId',
			tournamentStatus: 'tournaments/getCurrentTournamentStatus',
			tournament: 'tournaments/getCurrentTournament',
			currentRound: 'tournaments/getCurrentMatch',
			results: 'tournaments/getResults'
		}),
		isFinishRound () {
			return ['FINISHED', 'CLOSED'].includes(this.currentRound.match_status)
		},
		isAvailableParticipants () {
			return this.firstParticipant !== null && this.secondParticipant !== null
		},
		first: {
			get () {
				if (this.firstScore) return this.firstScore
				const findMy = this.results.find(item => item.reporter_id === this.user.id && item.type === 'INT' && item.value_state)

				if (findMy) {
					return findMy.value_state.split(':')[0]
				}

				return 0
			},
			set (value) {
				this.$set(this, 'firstScore', Math.abs(value))
			}
		},
		two: {
			get () {
				if (this.secondScore) return this.secondScore
				const findMy = this.results.find(item => item.reporter_id === this.user.id && item.type === 'INT')
				if (findMy) {
					return findMy.value_state.split(':')[1]
				}

				return 0
			},
			set (value) {
				this.$set(this, 'secondScore', Math.abs(value))
			}
		}
	},
	methods: {
		...mapActions({
			setResults: 'tournaments/setResults'
		}),
		isRevert (participant) {
			if (participant.type === 2) {
				if (!this.teams) {
					return false
				}
				const find = this.teams.find(item => item.id === participant.getId())
				return find
			}

			return participant.getId() === this.user.id
		},
		sendResult () {
			this.blockSendScore = true
			this.setResults({
				tournament_id: this.tournament_id,
				match_id: this.currentRound.id,
				data: {
					state: `${this.first}:${this.two}`
				}
			}).finally(() => {
				setTimeout(() => {
					this.blockSendScore = false
				}, 3000)
			})
		}
	},
	watch: {
		currentRound () {
			this.firstScore = 0
			this.secondScore = 0
		}
	},
	data () {
		return {
			blockSendScore: false,
			firstScore: this.second || 0,
			secondScore: this.two || 0
		}
	},
	components: {
		UiAvatar,
		UiButton
	}
}
</script>
<style scoped lang="scss">
	.round-result {
		background: #2F2F2F;
		box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2);
		border-radius: 5px;
		padding: 20px;
		.round-participants {
			.revert {
				grid-row: 1
			}
			display: grid;
			grid-template-columns: repeat(2, 1fr);
			grid-gap: 21px;
			margin-bottom: 20px;
			position: relative;
			.participant {
				box-shadow: 0px 0px 6px 0px rgba(0,231,223, 0.4);
				border: 1px solid #00E7DF;
				padding: 30px 0;
				border-radius: 5px;
				&.pointer {
					cursor: pointer;
				}
				&.disabled {
					box-shadow: 0px 0px 6px 0px rgba(0,0,0, 0.4);
					border: 1px solid gray
				}
				&.lose {
					border: 1px solid #D71411;
					box-shadow: 0px 0px 6px 0px rgba(215, 20, 17, 0.4);
					input {
						border: 1px solid #D71411 !important;
					}
				}
				&.none-border {
					border: none !important;
					box-shadow: none;
				}
				.avatar {
					margin: 0 auto;
				}
				.nickname {
					margin-top: 16px;
					margin-bottom: 10px;
					letter-spacing: 0.25px;
					font-size: 18px;
					line-height: 20px;
					text-align: center;
					width: 100%;
				}
				.psn {
					font-size: 10px;
					line-height: 16px;
					text-align: center;
					width: 100%;
					letter-spacing: 0.4px;
					text-transform: uppercase;
					color: #00E7DF;
				}
				.score-input {
					margin: 0 auto;
					margin-top: 25px;
					width: 156px;
					input {
						width: 100%;
						background: #2F2F2F;
						outline: none;
						padding: 6px 0;
						text-align: center;
						font-size: 36px;
						line-height: 46px;
						letter-spacing: -0.5px;
						&::placeholder {
							color: #8F8F8F;
						}
						color: #fff;
						border: 1px solid #505050;
						border-radius: 5px;
						&.is-active {
							border: 1px solid #00E7DF;
						}
						&[disabled] {
							color: gray
						}
					}
				}
			}
			.separator {
				position: absolute;
				top: calc(50% - 30px);
				height: 60px;
				box-shadow: 0px 0px 6px 0px rgba(0,231,223, 0.4);
				width: 60px;
				left: calc(50% - 30px);
				background: #2F2F2F;
				border: 1px solid #00E7DF;
				display: flex;
				align-items: center;
				justify-content: center;
				z-index: 1;
				border-radius: 100%;
			}
			&.conflict {
				.participant {
					box-shadow: 0px 0px 6px 0px rgba(255,16,16, 0.4);
					border: 1px solid #ff0f1a;
				}
				.separator {
					box-shadow: 0px 0px 6px 0px rgba(255,16,16, 0.4);
					border: 1px solid #ff0f1a;
				}
				.participant {
					input {
						border: 1px solid #ff0f1a !important;
					}
				}
			}
		}
		button {
			width: 100%;
			padding: 15px 0;
			display: flex;
			align-items: center;
			justify-content: center;
			&[disabled] {
				color: #00E7DF !important;
			}
			svg {
				margin-right: 10px;
				margin-bottom: 4px;
			}
		}
	}
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type=number] {
		-moz-appearance: textfield;
	}

	@media screen and (max-width: 768px) {
		.round-result {
			padding: 16px;
			.round-participants {
				.separator {
					top: 20px;
					box-shadow: none;
					border: none;
					width: 30px;
					left: calc(50% - 15px);
				}
				margin-bottom: 16px;
				.participant {
					padding-top: 0;
					padding-bottom: 0;
					.score-input {
						width: 100%;
						margin-top: 10px;
					}
					.nickname {
						margin-top: 9px;
						font-size: 14px;
						line-height: 20px;
						margin-bottom: 5px;
						max-width: 125px;
						text-overflow: ellipsis;
						overflow: hidden;
						text-align: center;
						margin-left: auto;
						margin-right: auto;
					}
				}
			}
		}
	}
</style>
